import React, { useState } from 'react';
import { ArrowRightIcon, XIcon } from 'lucide-react';
export function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return <div className="relative overflow-hidden bg-[#2a0f5e]" data-id="element-10" data-mp="jttuj4gyb1rv">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-90" style={{
      backgroundImage: 'linear-gradient(100deg, #1b0a3d 0%, #4a1fb0 28%, #8b3bd6 46%, #c0563f 72%, #e4772f 88%, #2a0f5e 100%)'
    }} data-id="element-11" data-mp="js91xke75swn" />
      <div className="relative mx-auto flex h-10 max-w-shell items-center gap-3 px-4 sm:px-8" data-id="element-12" data-mp="5sr6wnab5jeu">
        <a href="#announcement" className="group flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.14em] text-white/95" data-id="element-13" data-mp="w0uqb1mj7yp">
          <span className="grid h-4 w-4 place-items-center rounded-full border border-white/50 text-[9px]" data-id="element-14" data-mp="1v9s6bg3ik1ws">
            ∅
          </span>
          <span className="truncate" data-id="element-15" data-mp="1qap6qb6aynw7">Voidzero joins the toolchain collective</span>
          <span className="grid h-5 w-5 place-items-center rounded bg-black/70 text-white transition-transform duration-150 void-ease group-hover:translate-x-0.5" data-id="element-16" data-mp="67gwnlcax7xq">
            <ArrowRightIcon className="h-3 w-3" data-id="element-17" data-mp="3sfqb4mkofr8u" />
          </span>
        </a>
        <button type="button" onClick={() => setOpen(false)} aria-label="Dismiss announcement" className="ml-auto grid h-6 w-6 place-items-center rounded text-white/80 transition-colors duration-150 void-ease hover:bg-white/15 hover:text-white" data-id="element-18" data-mp="3sht8xss2moo4">
          <XIcon className="h-4 w-4" data-id="element-19" data-mp="tznllzfp6cn4" />
        </button>
      </div>
    </div>;
}